import {
    LocationPermissionUpdateRequest,
    LocationUserRole,
} from '@kcftech/prometheus-client';
import { SelectOption } from 'components/forms/Select';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { sdClient } from 'contexts/SDKClientContext';
import { LocationSpecificUserCellProps } from 'pages/Settings/Users/UsersTable';
import { InputHTMLAttributes, useMemo } from 'react';

const options = [
    { title: 'Admin', value: LocationUserRole.Admin },
    { title: 'User', value: LocationUserRole.User },
];

export function LocationUserRoleCell({
    rowData,
    onChange,
    locationId,
    disabled,
}: LocationSpecificUserCellProps &
    Pick<InputHTMLAttributes<HTMLInputElement>, 'disabled'>) {
    const selectedOption = useMemo(() => {
        const locationRole = rowData.Locations.find(
            ({ LocationId }) => LocationId === locationId,
        )?.LocationUserRole;
        return options.find((role) => role.value === locationRole);
    }, [locationId, rowData.Locations]);

    const onSave = async (newRole: SelectOption | undefined) => {
        if (!newRole) {
            throw new Error('Attempted to save location user role without a value');
        }
        try {
            await sdClient.updateLocationPermission({
                userId: rowData.Id,
                locationId,
                body: new LocationPermissionUpdateRequest({
                    LocationUserRole: newRole.value as LocationUserRole,
                }),
            });

            onChange();
        } catch {
            return 'Unable to save location role code';
        }
        return undefined;
    };

    return (
        <DropdownInlineEditor
            options={options}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.title,
                dataKey: (item) => item.value,
                renderItem: ({ item }) => item.title,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.title}
            onConfirm={onSave}
            isDisabled={disabled}
        />
    );
}
